import React, { useContext, useEffect, useState } from 'react';
import { notification } from 'antd';
import Loader from '../../../shared/loaders/Loader';
import { BookingContext } from '../../../shared/contexts/Booking.context';
import { useRouter } from 'next/router';
import { ThemeContext } from '../../../shared/contexts/Theme.context';
import { LanguageContext } from '../../../shared/contexts/Language.context';
import { OcrScanner, OcrScannerPropTypes } from 'civitfun-ocr-ui-component';
// import aliceUserTokenRequest from '../../../services/aliceUserToken.service';
import civitfunOcrUserDataRequest from '../../../services/civitfunOcrUserData.service';

let DocumentCapturerType, DocumentType;
let documentCapturerType;
let mode;
let cameraType;

export default function CivitfunOnboarding({
  visible,
  setVisible,
  nationality,
  documentType,
  selectedLanguage,
  literals,
  aliceSuccessAction,
  setLoadUserData,
}) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const {
    state: { hotelId, bookingCustomParameters },
  } = useContext(BookingContext);

  const {
    state: {
      isKiosk,
      cameraTypeAlice,
      documentCapturerTypeAlice,
      mainColor,
      secondaryColor,
      aliceAutomaticCapture,
      extraDocument
    },
  } = useContext(ThemeContext);

  const router = useRouter();
  const checkinGuestId = router.query.checkinGuestId;

  const [loading, setLoading] = useState(true);

  let automaticCapture = true;
  if (aliceAutomaticCapture !== undefined) {
    automaticCapture = aliceAutomaticCapture;
  }

  useEffect(() => {
    DocumentCapturerType = OcrScannerPropTypes.ALLOWED_SOURCES;
    DocumentType = OcrScannerPropTypes.DOCUMENT_TYPES;
    documentCapturerType = getDocumentCapturerFromDocumentType(documentType);

    if (isKiosk) {
      switch (documentCapturerTypeAlice) {
        case 'camera':
        default:
          mode = DocumentCapturerType.CAMERA;
          break;
        case 'file':
          mode = DocumentCapturerType.FILE;
          break;
        case 'all':
          mode = DocumentCapturerType.ALL;
          break;
      }

      cameraType =
        cameraTypeAlice === 'front'
          ? OcrScannerPropTypes.CAMERA_TYPES.FRONT
          : OcrScannerPropTypes.CAMERA_TYPES.BACK;
    } else {
      mode = DocumentCapturerType.ALL;
      cameraType = OcrScannerPropTypes.CAMERA_TYPES.BACK;
    }
    setLoading(false);
  }, []);

  // useEffect(() => {
  //   if (visible) {
  //     requestAliceToken();
  //   }
  // }, [visible]);

  function requestAliceToken() {
    // aliceUserTokenRequest(hotelId, language, checkinGuestId, issuingCountry)
    //   .then(response => {
    //     setLoading(false);
    //     onUserTokenLoaded(response.token);
    //   })
    //   .catch(_error => onFailure());
  }

  function onSuccess(images) {
    setLoading(true);
    const guestExtraData = bookingCustomParameters ? bookingCustomParameters[checkinGuestId] : {};
    civitfunOcrUserDataRequest(hotelId, selectedLanguage, checkinGuestId, documentType, guestExtraData, images)
      .then(response => {
        setVisible(false);
        aliceSuccessAction(response?.guestData || null);
      })
      .catch(error => {
        onFailure(error?.response?.data);
      });
  }

  function onFailure(error) {
    console.error(error);
    notification.error({
      message: literals['error.genericTitle'],
      description: error?.message || literals['error.genericDesc'],
    });
    setVisible(false);
    if (error?.error?.holderName === 'Not matches') requestAliceToken();
  }

  function onCancel() {
    setVisible(false);
  }

  function onUserTokenLoaded(userToken) {
    
  }

  return <div>
    {loading ? 
      <Loader></Loader> : 
      <OcrScanner 
        allowedSources={mode} 
        cameraType={cameraType}
        documentType={documentCapturerType}
        country={nationality}
        language={selectedLanguage}
        onComplete={onSuccess}
        onCancel={() => setVisible(false)}
      />
    }</div>;
}

function getDocumentCapturerFromDocumentType(documentType) {
  // Info. PCD code: Alemania : pasaporte de niños
  const isIdCardType =
    documentType?.startsWith('ID') ||
    documentType?.startsWith('I<') ||
    documentType?.startsWith('CIITA') ||
    documentType?.startsWith('C<ITA') ||
    documentType?.startsWith('CPBRA') ||
    documentType?.startsWith('INCHL');
  const isPassportType = documentType?.startsWith('P<') || documentType?.startsWith('PCD');
  const isResidenceType = documentType?.startsWith('IR');
  const isDriverLicenseType = documentType?.startsWith('DL');
  const isHeardInsuranceType = documentType?.startsWith('HIC');


  if (isIdCardType) {
    return DocumentType.IDCARD;
  } else if (isPassportType) {
    return DocumentType.PASSPORT;
  } else if (isResidenceType) {
    return DocumentType.RESIDENCEPERMIT;
  } else if (isDriverLicenseType) {
    return DocumentType.DRIVERLICENSE;
  } else if(isHeardInsuranceType){
    return DocumentType.HEALTHINSURANCECARD
  } else {
    return DocumentType.PASSPORT;
  }
}